import { format } from 'date-fns'
import { IRoutesPlanningFilters } from 'features/RoutesPlanning/models'
import { DATE_FORMAT } from 'utils/date'
import { getQueryString } from 'utils/route'

export const mapFormToQueryString = ({
  companyId,
  businessClientId,
  formValues
}: {
  companyId: string
  businessClientId: string
  formValues: IRoutesPlanningFilters
}): string => {
  const query = {
    companyId,
    businessClientId,
    businessSiteId: formValues.businessSite.id,
    routesIds: formValues.routes.map((route) => route.id).join(','),
    offerDateStartAt: formValues.offerDateRange.startAt ? format(formValues.offerDateRange.startAt, DATE_FORMAT) : '',
    offerDateEndAt: formValues.offerDateRange.endAt ? format(formValues.offerDateRange.endAt, DATE_FORMAT) : ''
  }

  return getQueryString(query)
}
